/**
 * filters-auto.js
 *
 * FILTRI AUTOMATICI COLLEZIONE – VERSIONE SEMPLICE
 *
 * Desktop:
 *   - Apre tutti i filtri presenti nella collezione
 *
 * Mobile:
 *   - Nessuna azione, l'utente seleziona manualmente i filtri
 *
 * Nota:
 *   - Eseguito solo su pagine collezione
 *   - Ottimizzato UX con micro-delay per evitare percezione di lentezza
 *   - Nessuna selezione automatica di Disponibile
 */

(function() {
  // Controllo pagina collezione
  if (!window.location.pathname.includes('/collections/')) return;

  const isDesktop = window.innerWidth > 768;
  if (!isDesktop) return;

  // Funzione per aprire tutti i filtri
  function openAllFilters() {
    const filters = document.querySelectorAll('.js-filter');
    if (!filters.length) return false; // filtri non ancora presenti

    filters.forEach(filtro => filtro.setAttribute('open', ''));
    return true;
  }

  // MutationObserver: aspetta che i filtri siano nel DOM
  const observer = new MutationObserver(() => {
    if (openAllFilters()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();
